// extracted by mini-css-extract-plugin
module.exports = {"notification":"notification-2OWHU","notification__text":"notification__text-3MCfK","notification__icon":"notification__icon-3lS03"};